var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "147px",
    height: "104px",
    viewBox: "0 0 147 104",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "F114E021-F001-4468-B2A2-C88DACB23952") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 147,
    height: 104,
    rx: 8
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "KIT",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elementler-KIT",
    transform: "translate(-1181.000000, -1376.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "BarChart",
    transform: "translate(1181.000000, 1376.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FAFAFC",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-48",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(29.000000, 17.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 90,
    height: 70
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-44",
    strokeWidth: 1,
    fill: "none",
    transform: "translate(9.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-41-Copy",
    stroke: "#C3C1C1",
    strokeDasharray: 2,
    strokeLinecap: "square",
    strokeWidth: 0.2
  }, /*#__PURE__*/React.createElement("line", {
    x1: 71.7567568,
    y1: 49.8648649,
    x2: 0.135135135,
    y2: 49.8648649,
    id: "Line-4-Copy-28"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71.7567568,
    y1: 37.4324324,
    x2: 0.135135135,
    y2: 37.4324324,
    id: "Line-4-Copy-29"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71.7567568,
    y1: 25,
    x2: 0.135135135,
    y2: 25,
    id: "Line-4-Copy-30"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71.7567568,
    y1: 12.5675676,
    x2: 0.135135135,
    y2: 12.5675676,
    id: "Line-4-Copy-31"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71.7567568,
    y1: 0.135135135,
    x2: 0.135135135,
    y2: 0.135135135,
    id: "Line-4-Copy-32"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-57",
    fill: "#979797",
    x: 0,
    y: 6.75675676,
    width: 6.21621622,
    height: 43.2432432
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-58",
    fill: "#979797",
    x: 24.3243243,
    y: 34.5945946,
    width: 6.21621622,
    height: 15.4054054
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-59",
    fill: "#979797",
    x: 36.4864865,
    y: 22.4324324,
    width: 6.21621622,
    height: 27.5675676
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-60",
    fill: "#979797",
    x: 48.1081081,
    y: 45.6756757,
    width: 6.21621622,
    height: 4.32432432
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-61",
    fill: "#979797",
    x: 60.2702703,
    y: 0,
    width: 6.21621622,
    height: 50
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-62",
    fill: "#979797",
    x: 12.1621622,
    y: 47.5675676,
    width: 6.21621622,
    height: 2.43243243
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarChart);
export default __webpack_public_path__ + "static/media/BarChart.0ef9a3bbfc95f7314d4f8531f7a4758a.svg";
export { ForwardRef as ReactComponent };